import React from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../../components/Icon";
import { downloadContract } from "../../../../../../services/contract.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Control = ({
  className,
  item, // Contrat à télécharger
}) => {
  const navigate = useNavigate();

  // Fonction de téléchargement du contrat en mode blob
  const handleDownload = async () => {
    if (!item) {
      console.error("Impossible de télécharger : aucun contrat fourni");
      toast.error("Impossible de télécharger le contrat");
      return;
    }

    try {
      // Toujours utiliser le service de téléchargement qui utilise le mode blob
      await downloadContract(item);
    } catch (error) {
      console.error("Erreur lors du téléchargement du contrat:", error);
      toast.error("Erreur lors du téléchargement du contrat");
    }
  };

  // Fonction pour naviguer vers la page de modification du contrat
  const handleEdit = () => {
    if (!item?.id) {
      toast.error("Impossible de modifier: ID du contrat manquant");
      return;
    }
    navigate(`/admin/contracts/${item.id}/edit`);
  };
  
  const actions = [
    {
      icon: "download",
      title: "Télécharger le document",
      action: () => handleDownload(),
    },
    {
      icon: "edit",
      title: "Modifier le document",
      action: () => handleEdit(),
    }
  ];

  return (
    <div className={cn(styles.control, className)}>
      {actions.map((x, index) => (
        <button 
          className={cn(styles.button, x.className)} 
          key={index} 
          onClick={x.action} 
          title={x.title}
        >
          <Icon name={x.icon} size="20" />
        </button>
      ))}
    </div>
  );
};

export default Control;
